import React from 'react';
// import { StateContext } from '../stateContext';
import { Helmet } from 'react-helmet';


function AboutPage() {
  return (
  <div className="flex flex-col justify-center mx-auto md:w-3/4 lg:w-1/2 space-y-8 p-6">
    <Helmet>
      <title>About Textractify | Extract Text from Videos and Photos</title>
      <meta name="description" content="Learn about Textractify, a tool to quickly extract text and numerical data from videos and photos, and export it in spreadsheet-friendly formats." />
      <meta name="keywords" content="Textractify, text extraction, OCR, video text, photo text, data extraction, CSV export" />
      <meta name="robots" content="index, follow" />
      <meta http-equiv="Content-Language" content="en" />

      {/* Open Graph */}
      <meta property="og:title" content="About Textractify | Extract Text from Videos and Photos" />
      <meta property="og:description" content="Learn about Textractify, a tool to quickly extract text and numerical data from videos and photos, and export it in spreadsheet-friendly formats." />
      <meta property="og:image" content="https://textractify.com/logo256.png" />
      <meta property="og:url" content="https://textractify.com/about" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Textractify" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="About Textractify | Extract Text from Videos and Photos" />
      <meta name="twitter:description" content="Learn about Textractify, a tool to quickly extract text and numerical data from videos and photos, and export it in spreadsheet-friendly formats." />
      <meta name="twitter:image" content="https://textractify.com/logo256.png" />
    </Helmet>
    {/* Page Title */}
    <h1 className="text-4xl font-bold text-center">About Textractify</h1>
    
    {/* Introduction */}
    <p className="text-lg text-center text-gray-700">
      Textractify is a powerful tool for quickly extracting text and numerical data from videos and photos, and exporting it in easy-to-use formats like CSV or TXT.
    </p>
    
    {/* How It Works */}
    <section className="space-y-4">
      <h2 className="text-2xl font-semibold">How It Works</h2>
      <p className="text-gray-700">
        Simply upload your video or images, select the area or type of text you want to capture, and Textractify uses advanced Optical Character Recognition (OCR) technology to extract the data. Once extracted, you can clean, organize, and export it for analysis or reporting.
      </p>
    </section>

    {/* Who It's For */}
    <section className="space-y-4">
      <h2 className="text-2xl font-semibold">Who It's For</h2>
      <p className="text-gray-700">
        Textractify is perfect for:
      </p>
      <ul className="list-disc list-inside text-gray-700 space-y-1">
        <li>Researchers analyzing video or photo datasets</li>
        <li>Educators and students extracting information from recorded lectures or presentations</li>
        <li>Content creators who want to gather on-screen text efficiently</li>
        <li>Analysts and engineers working with numerical data displayed in videos or charts</li>
      </ul>
    </section>

    {/* Why It Matters */}
    <section className="space-y-4">
      <h2 className="text-2xl font-semibold">Why It Matters</h2>
      <p className="text-gray-700">
        Traditionally, extracting text from videos or photos required manual entry, which is time-consuming and prone to errors. Textractify streamlines this process, allowing you to focus on analysis and insights rather than tedious data entry.
      </p>
    </section>

    {/* Call to Action */}
    <section className="text-center">
      <p className="text-gray-700">
        Whether you're working on research, education, or content analysis, Textractify provides a faster, more reliable way to turn visual information into actionable data.
      </p>
    </section>
  </div>
  );
}

export default AboutPage;